/**
 * Application Enums
 * 
 * Type-safe enumerations for application-wide use
 */

/**
 * Theme modes
 */
export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
  System = 'system'
}

/**
 * User roles
 */
export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER',
  Manager = 'MANAGER',
  Viewer = 'VIEWER'
}

/**
 * Subscription status
 */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Trial = 'TRIAL'
}

/**
 * Review sentiment
 */
export enum ReviewSentiment {
  Positive = 'POSITIVE',
  Neutral = 'NEUTRAL',
  Negative = 'NEGATIVE'
}

/**
 * App health status
 */
export enum AppHealthStatus {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR',
  Critical = 'CRITICAL'
}

/**
 * Notification priority
 */
export enum NotificationPriority {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Urgent = 'URGENT'
}

/**
 * Data loading state
 */
export enum LoadingState {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Success = 'SUCCESS',
  Error = 'ERROR'
}

/**
 * Sort direction
 */
export enum SortDirection {
  Ascending = 'ASC',
  Descending = 'DESC'
}

/**
 * Action types for audit logs
 */
export enum AuditActionType {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
  View = 'VIEW',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Export = 'EXPORT'
}

/**
 * Time period options
 */
export enum TimePeriod {
  ThisMonth = 'This Month',
  LastMonth = 'Last Month',
  Last3Months = 'Last 3 Months',
  ThisYear = 'This Year',
  AllTime = 'All Time'
}

/**
 * Chart types
 */
export enum ChartType {
  Line = 'line',
  Bar = 'bar',
  Pie = 'pie',
  Donut = 'donut',
  Area = 'area'
}

/**
 * Modal result types
 */
export enum ModalResult {
  Confirmed = 'CONFIRMED',
  Cancelled = 'CANCELLED',
  Dismissed = 'DISMISSED'
}







